// used both at runtime and build time
export const styleScope = 'transformations-style-scope';
